export const AMENITIES = {
  ON_SITE_LAUNDRY: "onSiteLaundry",
  YARD: "yard",
  CONCIERGE: "concierge",
  ELEVATOR: "elevator",
  DRY_CLEANING: "dryCleaning",
  GYM: "gym",
  SWIMMING_POOL: "swimmingPool",
  STORAGE: "storage",
  GUEST_SUITES: "guestSuites",
  BEANFIELD_WIFI: "beanfieldWifi",
  PUBLIC_WIFI: "publicWifi",
  BBQ_PERMITTED: "bbqPermitted",
  VISITORS_PARKING: "visitorsParking",
  PARTY_ROOM: "partyRoom",
  BIKE_STORAGE: "bikeStorage",
  WHEELCHAIR_ACCESS: "wheelchairAccess",
  ROOFTOP_DECK: "rooftopDeck",
  HOT_TUB: "hotTub",
  SAUNA: "sauna",
  GAM_EROOM: "gameRoom",
  THEATRE: "theatre",
  BUSINESS_CENTER: "businessCenter",
  COMMUNAL_GARDEN: "communalGarden",
  PET_SPA: "petSpa",
  MEDIA_ROOM: "mediaRoom",
  BASKETBALL_COURT: "basketballCourt",
  YOGA_ROOM: "yogaRoom",
  TENNIS_COURT: "tennisCourt",
  ROOFTOP_TERRACE: "rooftopTerrace",
  COWORKING_SPACE: "coworkingSpace",
  CONFERENCE_ROOM: "conferenceRoom",
  PATIO: "patio",
  LOUNGE: "lounge"
}

export const Amenities = [
  { name: "On-Site Laundry", value: AMENITIES.ON_SITE_LAUNDRY },
  { name: "Yard", value: AMENITIES.YARD },
  { name: "Concierge", value: AMENITIES.CONCIERGE },
  { name: "Elevator", value: AMENITIES.ELEVATOR },
  { name: "Dry Cleaning", value: AMENITIES.DRY_CLEANING },
  { name: "Gym", value: AMENITIES.GYM },
  { name: "Swimming Pool", value: AMENITIES.SWIMMING_POOL },
  { name: "Storage", value: AMENITIES.STORAGE },
  { name: "Guest Suites", value: AMENITIES.GUEST_SUITES },
  { name: "Beanfield Wi-Fi", value: AMENITIES.BEANFIELD_WIFI },
  { name: "Public Wi-Fi", value: AMENITIES.PUBLIC_WIFI },
  { name: "BBQ Permitted", value: AMENITIES.BBQ_PERMITTED },
  { name: "Visitors Parking", value: AMENITIES.VISITORS_PARKING },
  { name: "Party Room", value: AMENITIES.PARTY_ROOM },
  { name: "Bike Storage", value: AMENITIES.BIKE_STORAGE },
  { name: "Wheelchair Access", value: AMENITIES.WHEELCHAIR_ACCESS },
  { name: "Rooftop Deck", value: AMENITIES.ROOFTOP_DECK },
  { name: "Hot Tub", value: AMENITIES.HOT_TUB },
  { name: "Sauna", value: AMENITIES.SAUNA },
  { name: "Game Room", value: AMENITIES.GAM_EROOM },
  { name: "Theatre", value: AMENITIES.THEATRE },
  { name: "Business Center", value: AMENITIES.BUSINESS_CENTER },
  { name: "Communal Garden", value: AMENITIES.COMMUNAL_GARDEN },
  { name: "Pet Spa", value: AMENITIES.PET_SPA },
  { name: "Media Room", value: AMENITIES.MEDIA_ROOM },
  { name: "Basketball Court", value: AMENITIES.BASKETBALL_COURT },
  { name: "Yoga Room", value: AMENITIES.YOGA_ROOM },
  { name: "Tennis Court", value: AMENITIES.TENNIS_COURT },
  { name: "Rooftop Terrace", value: AMENITIES.ROOFTOP_TERRACE },
  { name: "Coworking Space", value: AMENITIES.COWORKING_SPACE },
  { name: "Conference Room", value: AMENITIES.CONFERENCE_ROOM },
  { name: "Patio", value: AMENITIES.PATIO },
  { name: "Lounge", value: AMENITIES.LOUNGE }
]
